import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { MessageHubService } from 'src/app/shared/services/message-hub.service';
import * as MessageHubActions from '../../../../../state/actions/message-hub.actions';
import * as AppHeaderActions from './actions/app-header.actions';

@Injectable()
export class AppHeaderEffects {

    constructor(private actions$: Actions,
        private messageHubService: MessageHubService) { }


    subscribeToBcsNotifications$ = createEffect(() => this.actions$
        .pipe(
            ofType(AppHeaderActions.loadBcsNotifications),
            switchMap(action => {
                this.messageHubService.subscribeToAlertUserGroup({
                    TenantId: action.tenantId,
                    UserId: action.userId,
                    FromUtcDate: action.fromUtcDate
                });
                return of(MessageHubActions.receivedActiveAlertsForUser({ messageData: "" }));//From where to get it?
            }
            )
        ));
}
